import script from "./LanguageOptions.vue?vue&type=script&setup=true&lang=ts"
export * from "./LanguageOptions.vue?vue&type=script&setup=true&lang=ts"

import "./LanguageOptions.vue?vue&type=style&index=0&id=5f185b44&lang=scss"

const __exports__ = script;

export default __exports__